class RezaLanding extends HTMLElement {
  constructor() {
    super()

    this.menuList = this.querySelector('ul')
    this.menuItems = this.querySelectorAll('.menu-item')
    this.startLink = this.querySelector('.start-link a')

    this.init()
  }

  init() {
    const { startLink, menuList, menuItems } = this

    if (startLink) {
      startLink.addEventListener("mouseenter", function () {
        menuList.classList.add("inactive")
      })
    
      startLink.addEventListener("mouseleave", function () {
        menuList.classList.remove("inactive")
      })
    }

    menuItems.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        item.classList.add('active')
        menuList.classList.add("inactive")
        startLink && startLink.classList.add("inactive")
      })

      item.addEventListener("mouseleave", () => {
        item.classList.remove('active')
        menuList.classList.remove("inactive")
        startLink && startLink.classList.remove("inactive")
      })
    })
  }
}

customElements.define("reza-landing", RezaLanding)
